export default __webpack_public_path__ + "static/media/origami.43d1bfa4.png";